import React, { useEffect, useState } from "react";
import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import { ReactComponent as MapPin } from "../../../../../assets/map/MapPin.svg";
import { ReactComponent as MapPinDark } from "../../../../../assets/map/MapPin_Dark.svg";
import { ReactComponent as Phone } from "../../../../../assets/map/Phone.svg";
import { ReactComponent as PhoneDark } from "../../../../../assets/map/Phone_Dark.svg";
import LocationIcon from "../../../../../assets/map/location.svg";
import useLocales from "../../../../../hooks/useLocales";
import ContactIcon from "../../../../../assets/MainPage/addBlock/countDown/call.svg";
import useSettings from "../../../../../hooks/useSettings";
import httpRequest from "../../../../../axios/index";
import ConfirmModal from "../../../../../components/dashboard/modal/Confirm";

import {
  setShowForm,
  setShowLocationData,
  setEditingLocation,
} from "../../../../../redux/slices/location/locationSlice";

import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { I18nextProvider } from "react-i18next";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";

const inputErrorClasses =
  "border-state_color_error placeholder:text-state_color_error dark:bg-dark-secondary";
const inputNoErrorClasses =
  "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color";

const EditLocationForms = ({ getLocationMapData, payloadPin, setPayload }) => {
  const { darkMode } = useSelector((state) => state.theme);
  const { allLangs, tComponent, handleLanguageChange } = useLocales();
  const dispatch = useDispatch();
  const { themeDirection } = useSettings();
  const { editingLocation } = useSelector((state) => state.location);
  const [isMainDefault, setIsMainDefault] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();
  // const { id } = useParams();

  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  useEffect(() => {
    editLocationList();
  }, []);

  useEffect(() => {
    if (payloadPin) {
      setValue("address", payloadPin?.address);
    }
  }, [payloadPin]);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const editLocationList = async () => {
    try {
      const url = `/api/user/editmap/${editingLocation}`;
      const response = await httpRequest.get(url);
      const resultSuccess = response?.data?.data;
      const status = response?.data?.status;

      if (status === "success") {
        setValue("title", resultSuccess?.title);
        setValue("address", resultSuccess?.address);
        setValue("phone", resultSuccess?.phone);
        setIsMainDefault(resultSuccess?.isPrimary);
        setSelectedLang(resultSuccess?.language);
        const matchedLang = allLangs?.find(
          (lang) => lang.value === resultSuccess?.language
        );
        const shouldSetLang = matchedLang?.label;
        setSelectedReporterType(shouldSetLang);
        handleLanguageChange(resultSuccess?.language);
      }
    } catch (error) {
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  const SubmitHandler = async (data) => {
    const { userid } = JSON.parse(localStorage.getItem("user"));
    const linkid = localStorage.getItem("linkId");
    try {
      const locationData = await geocodeAddress(data?.address);
      if (!locationData.lat || !locationData.lon) {
        toast.error("Please enter a correct address");
        return;
      }

      const payload = {
        coloum_name: "mapData",
        coloum_type: "mapData",
        link_id: linkid,
        userId: userid,
        title: data?.title,
        address: data?.address,
        phone: data?.phone,
        lat: locationData.lat,
        lon: locationData.lon,
        directionUrl: locationData.directionUrl,
        isPrimary: isMainDefault,
        mapId: editingLocation,
        language: selectedLang,
      };

      // const url = `/api/user/maps/${editingLocation}`;
      const url = `/api/user/updateLocationBlock`;
      const response = await httpRequest.put(url, payload);
      const result = response?.data?.message;
      const status = response?.data?.status;

      if (status === "success") {
        toast.success(result);
        setPayload(null);
        reset();
        // navigate("/dashboard/component/locationList");
        dispatch(setShowForm(false));
        dispatch(setShowLocationData(true));
        dispatch(setEditingLocation(null));
        getLocationMapData();
      }
    } catch (error) {
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  const geocodeAddress = async (address) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
          address
        )}`
      );
      const data = await response.json();
      if (data.length > 0) {
        const lat = parseFloat(data[0].lat);
        const lon = parseFloat(data[0].lon);
        const directionUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lon}`;
        return { lat, lon, directionUrl };
      } else {
        return {};
      }
    } catch (error) {
      // console.error('Error geocoding address:', error)
      return {};
    }
  };

  const handleDeleteLocation = async () => {
    const { userid } = JSON.parse(localStorage.getItem("user"));
    const linkid = localStorage.getItem("linkId");
    const payload = {
      coloum_name: "mapData",
      coloum_type: "mapData",
      link_id: linkid,
      userId: userid,
      language: selectedLang,
    };
    try {
      const url = `/api/user/maps/${editingLocation}/${payload?.link_id}/${payload?.userId}/${payload?.coloum_name}/${payload?.coloum_type}/${payload?.language}`;

      const response = await httpRequest.delete(url);
      const result = response?.data?.message;
      const status = response?.data?.status;

      if (status === "success") {
        toast.success(result);
        getLocationMapData();
        dispatch(setShowForm(false));
        dispatch(setShowLocationData(true));
        dispatch(setEditingLocation(null));
        setIsModalOpen(false);
      }
    } catch (error) {
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  return (
    <>
      <ConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onConfirm={handleDeleteLocation}
        selectedLang={selectedLang}
      />
      <I18nextProvider i18n={i18nForComponent}>
        <div
          className="relative mt-2"
          style={{
            direction: selectedLang === "ar" ? "rtl" : "ltr",
          }}
        >
          <form
            onSubmit={handleSubmit((data) => SubmitHandler(data))}
            className=" mt-4 bg-white p-6 border border-gray-300 rounded mt-2 dark:bg-dark-secondary dark:border-color_dark"
          >
            <div className="flex justify-between items-center mb-[20px] sm:mb-[25px]">
              <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark uppercase">
                {tComponent("location.edit_location")}
              </p>
              <div
                className={`w-[100px] bg-light_bg_v4 capitalize p-[10px] text-small2 lg:text-body_copy2 rounded-md flex justify-center items-center`}
              >
                {selectedReporterType ? selectedReporterType : "English"}
              </div>
            </div>

            <div>
            <label
              className="text-small2_b sm:text-small1_bold  text-heading_color dark:text-color_v1_dark uppercase"
              htmlFor="title"
            >
              {tComponent("location.adress_title_caps")}
            </label>
            <div className="flex flex-col lg:flex-row w-full">
              <div className="mt-4">
                <div>
                  <div className="relative">
                    <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                      {darkMode ? <MapPinDark /> : <MapPin />}
                    </div>
                    <input
                      type="text"
                      id="title"
                      name="title"
                      {...register("title", {
                        required: "Title is required",
                      })}
                      className={`rounded-md border bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                        errors.title
                          ? "border-state_color_error dark:bg-dark-secondary"
                          : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                      }`}
                      placeholder={tComponent("location.enter_location_name")}
                    />
                  </div>
                  {errors?.title && (
                    <small className="text-state_color_error text-small3">
                      {errors?.title?.message}
                    </small>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <label
              className="text-small2_b sm:text-small1_bold  text-heading_color dark:text-color_v1_dark uppercase"
              htmlFor="address"
            >
              {tComponent("location.adress_details_caps")}
            </label>
            <div className="flex flex-col lg:flex-row mt-4 w-full gap-2 mt-2">
              <div>
                <div className="relative">
                  <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                    {darkMode ? <MapPinDark /> : <MapPin />}
                  </div>
                  <input
                    type="text"
                    id="address"
                    name="address"
                    {...register("address", {
                      required: "Address is required",
                    })}
                    className={`rounded-md border bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                      errors.address
                        ? "border-state_color_error dark:bg-dark-secondary"
                        : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                    }`}
                    placeholder={tComponent("location.enter_location_adress")}
                  />
                </div>
                {errors?.address && (
                  <small className="text-state_color_error text-small3">
                    {errors?.address?.message}
                  </small>
                )}
              </div>

              <div>
                <div className="relative">
                  <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                    {darkMode ? <PhoneDark /> : <Phone />}
                  </div>
                  <input
                    type="number"
                    id="phone"
                    name="phone"
                    {...register("phone", {
                      required: "Phone is required",
                    })}
                    className={`rounded-md border bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                      errors.phone
                        ? "border-state_color_error dark:bg-dark-secondary"
                        : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                    }`}
                    placeholder={tComponent("location.enter_location_phone")}
                  />
                </div>
                {errors?.phone && (
                  <small className="text-state_color_error text-small3">
                    {errors?.phone?.message}
                  </small>
                )}
              </div>
            </div>
          </div>

            <label className="flex items-center mt-2">
              <input
                type="checkbox"
                className="h-5 w-5 accent-main_color dark:bg-dark-secondary rounded-md  bg-gray-100 border-gray-300 dark:bg-gray-700 dark:border-gray-600"
                checked={isMainDefault}
                onChange={(e) => setIsMainDefault(e.target.checked)}
              />
              <span className="ml-2 text-small3 text-gray-600 dark:text-[#737373]">
                {tComponent("location.set_default_location")}
              </span>
            </label>


            <div className="flex mt-[25px] cursor-pointer items-center justify-end">
              <div
                className="flex justify-center items-center"
                onClick={() => setIsModalOpen(true)}
              >
                {darkMode ? <TrashIconDark /> : <TrashIcon />}
                <p className="ps-1.5 pt-1 text-small3_b text-body_copy1_color dark:text-color_v1_dark">
                  {tComponent("location.delete_cap")}
                </p>
              </div>

              <ExtraSmallFilledButton
                name={`${tComponent("location.save_cap")}`}
                buttonType="submit"
                classes={"ms-3"}
              />
            </div>
          </form>
        </div>
      </I18nextProvider>
    </>
  );
};

export default EditLocationForms;
